import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  FaBoxOpen,
  FaHandshake,
  FaHeadset,
  FaHome,
  FaShoppingCart,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";

import { FaXmark } from "react-icons/fa6";
import { GiHamburgerMenu } from "react-icons/gi";

import {
  setAccessToken,
  setRefreshToken,
} from "../reducer/slices/authSlice";

import "react-toastify/dist/ReactToastify.css";
import "../ArtisitPages/Artist_navbar.css";

const PartnerSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("artId");

    toast.success("Successfully logged out", {
      position: "top-center",
    });

    navigate("/login");
  };

  const menuItems = [
    {
      name: "Dashboard",
      icon: <FaHome />,
      link: "/Partner_dashboard",
    },
    {
      name: "Profile",
      icon: <FaUser />,
      link: "/About_Partner",
    },
    // {
    //   name: "Product Inventory Management",
    //   icon: <FaBoxOpen />,
    //   link: "/SellProduct",
    // },
    {
      name: "Orders",
      icon: <FaShoppingCart />,
      link: "/Partner_Orders",
    },
    {
      name: "Collaboration",
      icon: <FaHandshake />,
      link: "/Partner_Collaboration",
    },
    {
      name: "Contact Us / Support",
      icon: <FaHeadset />,
      link: "/Partner_Support",
    },
    {
      name: "Logout",
      icon: <FaSignOutAlt />,
      action: handleLogout,
    },
  ];

  const isActiveRoute = (link) => {
    return (
      location.pathname === link ||
      location.pathname.startsWith(`${link}/`)
    );
  };

  return (
    // <aside
    //   className="sidebar"
    //   style={{
    //     width: isOpen ? "250px" : "80px",
    //     transition: "width 0.3s ease",
    //   }}
    // >
    //   <div
    //     className="sidebar-title"
    //     style={{
    //       color: "#fff",
    //       cursor: "pointer",
    //     }}
    //   >
    //     {isOpen ? (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //           padding: "0 15px 0 20px",
    //         }}
    //       >
    //         <span>Partner Panel</span>

    //         <button
    //           type="button"
    //           onClick={() => setIsOpen(false)}
    //           aria-label="Close sidebar"
    //           style={{
    //             border: "none",
    //             background: "transparent",
    //             color: "#fff",
    //             cursor: "pointer",
    //             fontSize: "26px",
    //             display: "flex",
    //             alignItems: "center",
    //           }}
    //         >
    //           <FaXmark />
    //         </button>
    //       </div>
    //     ) : (
    //       <button
    //         type="button"
    //         onClick={() => setIsOpen(true)}
    //         aria-label="Open sidebar"
    //         style={{
    //           width: "100%",
    //           border: "none",
    //           background: "transparent",
    //           color: "#fff",
    //           cursor: "pointer",
    //           fontSize: "24px",
    //           display: "flex",
    //           justifyContent: "center",
    //         }}
    //       >
    //         <GiHamburgerMenu />
    //       </button>
    //     )}
    //   </div>

    //   <ul className="sidebar-menu">
    //     {menuItems.map((item) => (
    //       <li key={item.name}>
    //         {item.action ? (
    //           <button
    //             type="button"
    //             className="sidebar-link"
    //             onClick={item.action}
    //             style={{
    //               justifyContent: isOpen
    //                 ? "flex-start"
    //                 : "center",
    //               width: "100%",
    //             }}
    //           >
    //             <span className="sidebar-icon">
    //               {item.icon}
    //             </span>

    //             {!isOpen && (
    //               <span className="tooltip">
    //                 {item.name}
    //               </span>
    //             )}

    //             {isOpen && (
    //               <span className="sidebar-text">
    //                 {item.name}
    //               </span>
    //             )}
    //           </button>
    //         ) : (
    //           <Link
    //             to={item.link}
    //             className={`sidebar-link ${
    //               isActiveRoute(item.link)
    //                 ? "active"
    //                 : ""
    //             }`}
    //             style={{
    //               justifyContent: isOpen
    //                 ? "flex-start"
    //                 : "center",
    //             }}
    //           >
    //             <span className="sidebar-icon">
    //               {item.icon}
    //             </span>

    //             {!isOpen && (
    //               <span className="tooltip">
    //                 {item.name}
    //               </span>
    //             )}

    //             {isOpen && (
    //               <span className="sidebar-text">
    //                 {item.name}
    //               </span>
    //             )}
    //           </Link>
    //         )}
    //       </li>
    //     ))}
    //   </ul>
    // </aside>

    <aside className="sidebar" style={{width: isOpen ? "250px" : "80px", transition: "width 0.3s"}}>
      <h2 className="sidebar-title" style={{cursor: "pointer", color:"#fff", alignContent:"center"}}>{isOpen ? <p style={{display: "flex", alignItems:"center", justifyContent:"space-between", padding:"0px 10px 0px 20px"}}> Menu <span style={{fontWeight:"600", fontSize:"30px"}}> <FaXmark onClick={()=> setIsOpen(!isOpen)} style={{alignSelf:"end"}} /> </span> </p> : <p onClick={()=> setIsOpen(!isOpen)} style={{display:"flex", justifyContent:"center"}}> <GiHamburgerMenu /> </p>}</h2>
      <ul className="sidebar-menu">
        {menuItems.map((item, i) => (
          <li key={i}>
            {item.action ? (
              <button className="sidebar-link" style={{justifyContent: isOpen ? "flex-start" : "center", width:"100%"}} onClick={item.action}>
                <span className="sidebar-icon">{item.icon}</span>
                {
                    isOpen && (<span className="sidebar-text">{item.name}</span>)
                }
              </button>
            ) : (
              <Link
                to={item.link}
                className={`sidebar-link ${
                  location.pathname === item.link ? "active" : ""
                }`} style={{justifyContent: isOpen ? "flex-start" : "center"}}
              >
                <span className="sidebar-icon">{item.icon}</span>
                {!isOpen && <span className="tooltip">{item.name}</span>}
                {
                    isOpen && (<span className="sidebar-text">{item.name}</span>)
                }
              </Link>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default PartnerSidebar;